import actionTypes from './actionTypes';

const initialState = {
  data: [],
  isFetching: true,
  filters: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH:
      return {
        ...state,
        isFetching: true,
        data: [],
        filters: action.payload.filters ? action.payload.filters : state.filters,
      };

    case actionTypes.FETCHING:
      return {
        ...state,
        isFetching: true,
        data: [],
      };

    case actionTypes.FETCHED:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
        nextCursor: action.meta.nextCursor ? action.meta.nextCursor : null,
        prevCursor: action.meta.prevCursor ? action.meta.prevCursor : null,
        filters: action.meta.filters ? action.meta.filters : {},
      };

    case actionTypes.UPDATE_SHIPMENT:
      return {
        ...state,
        data: state.data.map((shipment) => {
          if (shipment.shipmentId === action.payload.shipmentId) {
            return {
              ...shipment,
              ...action.payload,
            };
          }
          return shipment;
        }),
      };

    case actionTypes.CANCEL:
      return {
        ...state,
        data: state.data.map((shipment) => {
          if (shipment.shipmentId === action.payload.shipmentId) {
            return {
              ...shipment,
              isCancelling: true,
            };
          }
          return shipment;
        }),
      };
    case actionTypes.CANCELLED:
      return {
        ...state,
        data: state.data.map((shipment) => {
          if (shipment.shipmentId === action.payload.shipmentId) {
            return {
              ...shipment,
              isCancelling: false,
            };
          }
          return shipment;
        }),
      };
    default:
      return state;
  }
};
